import 'jquery-validation';
import {showButtonLoader, hideButtonLoader} from '../../util/helpers';

export default {
  init: function () {

    var preferencesForm = $('#accountForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);
      
      setTimeout(() => {
        var valid = preferencesForm.valid();
        if (valid) {
          setTimeout(function () {
            preferencesForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account/preferences.js